import styles from './security-certificate-badge.css?url'

export * from './security-certificate-badge'
export const links = () => [{ rel: 'stylesheet', href: styles }]
